<div [class]="expandLeftNav ? 'sidebar' : 'sidebar close'">
    <div class="logo-details">
        <i *ngIf="!expandLeftNav" matTooltip="Click to expand" matTooltipPosition="right" class='bi bi-list' style="cursor: pointer;" (click)="onLeftNavToggle()"></i>
        <!-- <i *ngIf="expandLeftNav" class="bi bi-building" style="cursor: pointer;" (click)="onLeftNavToggle()"></i> -->
        <div *ngIf="expandLeftNav" style="margin-top: 5px;">
            <img width="55px" height="55px" src="../../../assets/HomeLogo_white.png" style="cursor: pointer; margin: 10px;" alt="profileImg"
                (click)="onLeftNavToggle()">
        </div>
        <span class="logo_name" *ngIf="userDetails?.zoneIds?.includes(1)">MES Kochi Zone</span>
        <span class="logo_name" *ngIf="userDetails?.zoneIds?.includes(2)">MES Ezhimala Zone</span>
        <span class="logo_name" *ngIf="userDetails?.zoneIds?.includes(4)">MES Lonavala Zone</span>
    </div>
    <ul class="nav-links">
        <li *ngFor="let menu of userMenu; let i = index;" [class]="menu.defaultExpanded ? 'showMenu' : ''">
            <ng-container *ngIf="menu.subMenuItems.length > 0">
                <div class="icon-link">
                    <a [routerLink]="menu.route">
                        <i [class]='menu.icon'></i>
                        <span class="link_name">{{ menu.name === 'My People' ? menu.name + '&#42;' : menu.name }}</span>
                    </a>
                    <i class='bi bi-chevron-down arrow' (click)="onExpandMenuItem(i)"></i>
                </div>
                <ul class="sub-menu">
                    <li><a class="link_name" [routerLink]="menu.route">{{ menu.name }}</a></li>
                    <li *ngFor="let subMenu of menu.subMenuItems">
                        <a [routerLink]="subMenu.route">{{ subMenu.name }}</a>
                    </li>
                </ul>
            </ng-container>
            <ng-container *ngIf="menu.subMenuItems.length === 0">
                <a [routerLink]="menu.route">
                    <i [class]='menu.icon'></i>
                    <span class="link_name">{{ menu.name }}</span>
                </a>
                <ul class="sub-menu blank">
                    <li><a class="link_name" [routerLink]="menu.route">{{ menu.name }}</a></li>
                </ul>
            </ng-container>
        </li>
        <li>
            <div class="profile-details">
                <div class="profile-content">
                    <img src="../../../assets/images/user_image.png" style="cursor: pointer;" alt="profileImg"
                        (click)="onLeftNavToggle()" [matTooltip]="userDetails?.userName?.toString()">
                </div>
                <div>
                    <div class="profile_name">{{ userDetails?.userName?.toLowerCase() }}</div>
                    <div class="username">{{ getUserGroup(userDetails?.userType).replace(' Role', '') }}</div>
                </div>
                <i class='bi bi-box-arrow-left' matTooltip="Logout" matTooltipPosition="right" (click)="userLogout()"></i>
            </div>
        </li>
    </ul>
</div>
<section class="home-section">
    <div class="home-content">
        <span class="text" style="margin: 5px;">{{ title }}</span>
        <div>
            <button *ngIf="userDetails?.userType === 'ROLE_USER'" mat-button style="margin-right: 10px;" (click)="createNewComplaint()">
                <mat-icon>library_add</mat-icon>
                Book New Complaint
            </button>
            <button mat-flat-button [matMenuTriggerFor]="menu">
                <mat-icon>person_pin</mat-icon>
                My Account
            </button>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="userProfile()">
                <mat-icon>shield_person</mat-icon>
                <span>Profile</span>
            </button>
            <button mat-menu-item (click)="changePassword()">
                <mat-icon>lock_reset</mat-icon>
                <span>Change Password</span>
            </button>
            <button mat-menu-item (click)="userLogout()">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
            </button>
        </mat-menu>
    </div>
    <div style="margin: 20px;">
        <router-outlet></router-outlet>
    </div>
</section>